import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'lib-item-summary-back-to-pricing-button',
  templateUrl: './back-to-pricing.component.html'
})
export class BackToPricingComponent implements OnInit {

  ngOnInit(): void {
  }

  backToPricingAction(): void{
    window.close();
  }

}
